import {Grid, Typography} from '@mui/material';
import {getFetchCart} from '../../../api/cart.api';
import {
    CartItemPayload,
    BuyerDTO,
    CartDTO,
    FetchCartDTO,
    APIResponse,
    HttpResponse,
    APIResponseType,
} from '../../../api/models';
import {useEventBatching} from '../../../api/events';
import {AxiosError} from 'axios';

export const FetchCartItemDetailsButton = ({
    websiteId,
    currCartItems,
    isButtonDisabled,
    setCartDTO,
    buyerDTO,
}: {
    isButtonDisabled: boolean;
    currCartItems: CartItemPayload[];
    buyerDTO: BuyerDTO;
    setCartDTO: (updatedCartDTO: CartDTO) => void;
    websiteId?: string;
}) => {
    const {trackEvent} = useEventBatching();

    return (
        <Grid container>
            <Grid item md={3} xs={12} sm={12} lg={3} xl={3}>
                <div
                    onClick={async () => {
                        const cartItems = currCartItems.map((item) => {
                            return {
                                catalogId: item.id,
                                quantity: item.quantity,
                            };
                        });
                        if (websiteId) {
                            if (!isButtonDisabled) {
                                const fetchCartDTO: FetchCartDTO = {
                                    items: cartItems,
                                    websiteId: websiteId,
                                    buyerDTO: buyerDTO,
                                };
                                try {
                                    const response = await getFetchCart(fetchCartDTO);
                                    setCartDTO(response);
                                } catch (error: any) {
                                    if (error.name === 'AxiosError') {
                                        const err = error as AxiosError;
                                        const message = err.response?.data as APIResponse;
                                        if (message.type === APIResponseType.ErrorString) {
                                            const httpResponse = message.data as HttpResponse;
                                            trackEvent({
                                                eventName: 'Fetch Cart: FAILED',
                                                props: {
                                                    ...{
                                                        errorMessage: httpResponse.message.toString(),
                                                        cartDTO: JSON.stringify(fetchCartDTO),
                                                    },
                                                },
                                            });
                                        }
                                    } else {
                                        trackEvent({
                                            eventName: 'Fetch Cart: FAILED',
                                            props: {
                                                ...{
                                                    errorMessage: error.message.toString(),
                                                },
                                                cartDTO: JSON.stringify(fetchCartDTO),
                                            },
                                        });
                                    }
                                }
                            }
                        }
                    }}
                    style={{
                        paddingTop: 12,
                        paddingBottom: 12,
                        paddingLeft: 32,
                        borderRadius: 8,
                        paddingRight: 32,
                        cursor: isButtonDisabled ? 'default' : 'pointer',
                        backgroundColor: isButtonDisabled ? 'gray' : '#15171c',
                    }}>
                    <center>
                        <Typography
                            sx={{
                                fontWeight: 700,
                                color: 'white',
                                fontFamily: 'Poppins',
                            }}
                            variant='body1'>
                            Confirm order
                        </Typography>
                    </center>
                </div>
            </Grid>
        </Grid>
    );
};
